import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// `npm run start:local-auth` signs in against a local Auth emulator with a
// seeded test admin (scripts/local-auth.js), so the UI can be reviewed without a
// real account. Production builds strip this branch, and the build refuses
// to run with the flag set.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_AUTH_EMULATOR === 'true') {
  connectAuthEmulator(auth, `http://127.0.0.1:${process.env.REACT_APP_AUTH_EMULATOR_PORT || '9099'}`, { disableWarnings: true });
}
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
